var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 177,
    viewBox: "0 0 384 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_398_3098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.5 85.5L-3 128.5V183.5H393L388 0L326.5 33.5L230.5 42L152.5 77L79.5 85.5Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5 85.5L-3 128.5V183.5H393L388 0L326.5 33.5L230.5 42L152.5 77L79.5 85.5Z",
    fill: "#E1E7F8",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_398_3098)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 81,
    width: 12,
    height: 12,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.25,
    y: 81.25,
    width: 11.5,
    height: 11.5,
    rx: 5.75,
    stroke: "#E2E8F0",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 87,
    r: 4,
    fill: "#4659CA"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_398_3098)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 71,
    width: 12,
    height: 12,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.25,
    y: 71.25,
    width: 11.5,
    height: 11.5,
    rx: 5.75,
    stroke: "#E2E8F0",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 77,
    r: 4,
    fill: "#4659CA"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_398_3098)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 37,
    width: 12,
    height: 12,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.25,
    y: 37.25,
    width: 11.5,
    height: 11.5,
    rx: 5.75,
    stroke: "#E2E8F0",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 43,
    r: 4,
    fill: "#4659CA"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_398_3098)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 321,
    y: 27,
    width: 12,
    height: 12,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.25,
    y: 27.25,
    width: 11.5,
    height: 11.5,
    rx: 5.75,
    stroke: "#E2E8F0",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 327,
    cy: 33,
    r: 4,
    fill: "#4659CA"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 37.5,
    width: 51,
    height: 33,
    rx: 7.5,
    fill: "#E1E7F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 37.5,
    width: 51,
    height: 33,
    rx: 7.5,
    stroke: "#4659CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.83 48.2C40.174 48.2 41.2893 48.6713 42.176 49.614C43.072 50.5567 43.52 51.7187 43.52 53.1C43.52 54.472 43.072 55.634 42.176 56.586C41.2893 57.5287 40.174 58 38.83 58H34.98V48.2H38.83ZM38.83 56.46C39.754 56.46 40.5053 56.1427 41.084 55.508C41.672 54.8733 41.966 54.0707 41.966 53.1C41.966 52.12 41.672 51.3173 41.084 50.692C40.5053 50.0573 39.754 49.74 38.83 49.74H36.59V56.46H38.83ZM48.1607 58.182C47.218 58.182 46.4153 57.9673 45.7527 57.538C45.0993 57.1087 44.642 56.5207 44.3807 55.774L45.7667 54.962C46.1587 56.0633 46.9707 56.614 48.2027 56.614C48.8093 56.614 49.262 56.4973 49.5607 56.264C49.8687 56.0213 50.0227 55.7087 50.0227 55.326C50.0227 54.9247 49.8593 54.6213 49.5327 54.416C49.206 54.2013 48.6273 53.968 47.7967 53.716C47.33 53.576 46.952 53.4453 46.6627 53.324C46.3733 53.2027 46.0653 53.0347 45.7387 52.82C45.4213 52.596 45.1833 52.3207 45.0247 51.994C44.866 51.6673 44.7867 51.2847 44.7867 50.846C44.7867 49.978 45.0947 49.292 45.7107 48.788C46.3267 48.2747 47.0687 48.018 47.9367 48.018C48.7207 48.018 49.4067 48.2093 49.9947 48.592C50.5827 48.9747 51.0353 49.502 51.3527 50.174L49.9947 50.958C49.584 50.0433 48.898 49.586 47.9367 49.586C47.47 49.586 47.0967 49.698 46.8167 49.922C46.5367 50.1367 46.3967 50.4307 46.3967 50.804C46.3967 51.168 46.5367 51.4573 46.8167 51.672C47.106 51.8773 47.624 52.0967 48.3707 52.33C48.744 52.4513 49.0147 52.5447 49.1827 52.61C49.36 52.666 49.6027 52.7593 49.9107 52.89C50.228 53.0207 50.466 53.1513 50.6247 53.282C50.7833 53.4127 50.9513 53.576 51.1287 53.772C51.3153 53.968 51.446 54.192 51.5207 54.444C51.5953 54.696 51.6327 54.9807 51.6327 55.298C51.6327 56.1847 51.3107 56.8893 50.6667 57.412C50.032 57.9253 49.1967 58.182 48.1607 58.182ZM59.5607 58L58.8747 56.026H54.7027L54.0167 58H52.2667L55.8227 48.2H57.7547L61.2967 58H59.5607ZM55.2347 54.514H58.3427L56.7887 50.09L55.2347 54.514Z",
    fill: "#282D72"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 91.5,
    width: 92,
    height: 33,
    rx: 7.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 91.5,
    width: 92,
    height: 33,
    rx: 7.5,
    stroke: "#4659CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.59 110.46H152.58V112H146.98V102.2H148.59V110.46ZM155.665 110.46H159.655V112H154.055V102.2H155.665V110.46ZM164.98 102.2C166.324 102.2 167.439 102.671 168.326 103.614C169.222 104.557 169.67 105.719 169.67 107.1C169.67 108.472 169.222 109.634 168.326 110.586C167.439 111.529 166.324 112 164.98 112H161.13V102.2H164.98ZM164.98 110.46C165.904 110.46 166.655 110.143 167.234 109.508C167.822 108.873 168.116 108.071 168.116 107.1C168.116 106.12 167.822 105.317 167.234 104.692C166.655 104.057 165.904 103.74 164.98 103.74H162.74V110.46H164.98ZM183.248 111.51L181.946 112.266L181.008 111.258C180.233 111.874 179.323 112.182 178.278 112.182C177.279 112.182 176.467 111.925 175.842 111.412C175.226 110.899 174.918 110.199 174.918 109.312C174.918 108.724 175.062 108.183 175.352 107.688C175.65 107.193 176.08 106.797 176.64 106.498C176.266 105.985 176.08 105.415 176.08 104.79C176.08 103.969 176.364 103.301 176.934 102.788C177.512 102.275 178.222 102.018 179.062 102.018C179.734 102.018 180.34 102.195 180.882 102.55C181.423 102.905 181.824 103.409 182.086 104.062L180.714 104.846C180.583 104.454 180.373 104.146 180.084 103.922C179.794 103.698 179.458 103.586 179.076 103.586C178.684 103.586 178.352 103.703 178.082 103.936C177.82 104.16 177.69 104.459 177.69 104.832C177.69 105.028 177.732 105.224 177.816 105.42C177.9 105.616 177.988 105.779 178.082 105.91C178.184 106.031 178.334 106.195 178.53 106.4L180.91 108.976C181.143 108.5 181.311 107.931 181.414 107.268L182.786 108.052C182.618 108.836 182.347 109.527 181.974 110.124L183.248 111.51ZM178.362 110.684C178.987 110.684 179.528 110.511 179.986 110.166L177.578 107.576C176.887 107.921 176.542 108.458 176.542 109.186C176.542 109.643 176.7 110.007 177.018 110.278C177.335 110.549 177.783 110.684 178.362 110.684ZM194.419 102.2H196.029V112H194.419V107.758H190.219V112H188.609V102.2H190.219V106.218H194.419V102.2ZM199.878 110.46H203.868V112H198.268V102.2H199.878V110.46ZM209.193 102.2C210.537 102.2 211.652 102.671 212.539 103.614C213.435 104.557 213.883 105.719 213.883 107.1C213.883 108.472 213.435 109.634 212.539 110.586C211.652 111.529 210.537 112 209.193 112H205.343V102.2H209.193ZM209.193 110.46C210.117 110.46 210.868 110.143 211.447 109.508C212.035 108.873 212.329 108.071 212.329 107.1C212.329 106.12 212.035 105.317 211.447 104.692C210.868 104.057 210.117 103.74 209.193 103.74H206.953V110.46H209.193Z",
    fill: "#282D72"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.5,
    y: 0.5,
    width: 86,
    height: 33,
    rx: 7.5,
    fill: "#E1E7F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.5,
    y: 0.5,
    width: 86,
    height: 33,
    rx: 7.5,
    stroke: "#4659CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.72 12.74H154.59V15.484H158.58V17.024H154.59V21H152.98V11.2H158.72V12.74ZM165.126 14H166.638V21H165.126V20.104C164.669 20.8227 163.945 21.182 162.956 21.182C162.153 21.182 161.505 20.9253 161.01 20.412C160.515 19.8987 160.268 19.194 160.268 18.298V14H161.78V18.144C161.78 18.6667 161.92 19.068 162.2 19.348C162.48 19.628 162.863 19.768 163.348 19.768C163.88 19.768 164.309 19.6047 164.636 19.278C164.963 18.942 165.126 18.4333 165.126 17.752V14ZM168.686 21V10.78H170.198V21H168.686ZM172.234 21V10.78H173.746V21H172.234ZM180.919 15.932C180.919 16.1653 181.045 16.352 181.297 16.492C181.559 16.6227 181.871 16.7393 182.235 16.842C182.609 16.9353 182.982 17.0473 183.355 17.178C183.729 17.3087 184.041 17.5327 184.293 17.85C184.555 18.158 184.685 18.55 184.685 19.026C184.685 19.698 184.424 20.2253 183.901 20.608C183.388 20.9907 182.739 21.182 181.955 21.182C181.265 21.182 180.672 21.0373 180.177 20.748C179.683 20.4587 179.323 20.0573 179.099 19.544L180.401 18.788C180.644 19.46 181.162 19.796 181.955 19.796C182.749 19.796 183.145 19.5347 183.145 19.012C183.145 18.788 183.015 18.606 182.753 18.466C182.501 18.326 182.189 18.2093 181.815 18.116C181.451 18.0133 181.083 17.8967 180.709 17.766C180.336 17.6353 180.019 17.4207 179.757 17.122C179.505 16.814 179.379 16.4267 179.379 15.96C179.379 15.316 179.622 14.798 180.107 14.406C180.602 14.014 181.213 13.818 181.941 13.818C182.52 13.818 183.033 13.9487 183.481 14.21C183.939 14.462 184.289 14.8167 184.531 15.274L183.257 15.988C183.015 15.456 182.576 15.19 181.941 15.19C181.652 15.19 181.409 15.2553 181.213 15.386C181.017 15.5073 180.919 15.6893 180.919 15.932ZM189.927 15.456H188.191V18.816C188.191 19.1053 188.256 19.3153 188.387 19.446C188.518 19.5673 188.709 19.6373 188.961 19.656C189.222 19.6653 189.544 19.6607 189.927 19.642V21C188.77 21.14 187.939 21.042 187.435 20.706C186.931 20.3607 186.679 19.7307 186.679 18.816V15.456H185.391V14H186.679V12.488L188.191 12.04V14H189.927V15.456ZM196.835 14H198.347V21H196.835V19.992C196.266 20.7853 195.449 21.182 194.385 21.182C193.424 21.182 192.603 20.8273 191.921 20.118C191.24 19.3993 190.899 18.5267 190.899 17.5C190.899 16.464 191.24 15.5913 191.921 14.882C192.603 14.1727 193.424 13.818 194.385 13.818C195.449 13.818 196.266 14.21 196.835 14.994V14ZM193.041 19.11C193.461 19.53 193.989 19.74 194.623 19.74C195.258 19.74 195.785 19.53 196.205 19.11C196.625 18.6807 196.835 18.144 196.835 17.5C196.835 16.856 196.625 16.324 196.205 15.904C195.785 15.4747 195.258 15.26 194.623 15.26C193.989 15.26 193.461 15.4747 193.041 15.904C192.621 16.324 192.411 16.856 192.411 17.5C192.411 18.144 192.621 18.6807 193.041 19.11ZM203.694 21.182C202.639 21.182 201.757 20.8273 201.048 20.118C200.348 19.4087 199.998 18.536 199.998 17.5C199.998 16.4547 200.348 15.582 201.048 14.882C201.757 14.1727 202.639 13.818 203.694 13.818C204.375 13.818 204.996 13.9813 205.556 14.308C206.116 14.6347 206.536 15.0733 206.816 15.624L205.514 16.38C205.355 16.044 205.112 15.7827 204.786 15.596C204.468 15.4 204.1 15.302 203.68 15.302C203.064 15.302 202.546 15.512 202.126 15.932C201.715 16.352 201.51 16.8747 201.51 17.5C201.51 18.1253 201.715 18.648 202.126 19.068C202.546 19.488 203.064 19.698 203.68 19.698C204.09 19.698 204.459 19.6 204.786 19.404C205.122 19.208 205.374 18.9467 205.542 18.62L206.844 19.362C206.545 19.922 206.116 20.3653 205.556 20.692C204.996 21.0187 204.375 21.182 203.694 21.182ZM214.404 21H212.598L209.728 17.766V21H208.216V11.2H209.728V17.094L212.444 14H214.292L211.212 17.43L214.404 21Z",
    fill: "#282D72"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.5,
    y: 49.5,
    width: 86,
    height: 33,
    rx: 7.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.5,
    y: 49.5,
    width: 86,
    height: 33,
    rx: 7.5,
    stroke: "#4659CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.59 68.46H269.58V70H263.98V60.2H265.59V68.46ZM272.665 68.46H276.655V70H271.055V60.2H272.665V68.46ZM287.51 60.2V70H285.9V63.014L282.918 67.942H282.722L279.74 63V70H278.13V60.2H279.866L282.82 65.1L285.788 60.2H287.51ZM291.004 64.932C291.004 65.1653 291.13 65.352 291.382 65.492C291.643 65.6227 291.956 65.7393 292.32 65.842C292.693 65.9353 293.066 66.0473 293.44 66.178C293.813 66.3087 294.126 66.5327 294.378 66.85C294.639 67.158 294.77 67.55 294.77 68.026C294.77 68.698 294.508 69.2253 293.986 69.608C293.472 69.9907 292.824 70.182 292.04 70.182C291.349 70.182 290.756 70.0373 290.262 69.748C289.767 69.4587 289.408 69.0573 289.184 68.544L290.486 67.788C290.728 68.46 291.246 68.796 292.04 68.796C292.833 68.796 293.23 68.5347 293.23 68.012C293.23 67.788 293.099 67.606 292.838 67.466C292.586 67.326 292.273 67.2093 291.9 67.116C291.536 67.0133 291.167 66.8967 290.794 66.766C290.42 66.6353 290.103 66.4207 289.842 66.122C289.59 65.814 289.464 65.4267 289.464 64.96C289.464 64.316 289.706 63.798 290.192 63.406C290.686 63.014 291.298 62.818 292.026 62.818C292.604 62.818 293.118 62.9487 293.566 63.21C294.023 63.462 294.373 63.8167 294.616 64.274L293.342 64.988C293.099 64.456 292.66 64.19 292.026 64.19C291.736 64.19 291.494 64.2553 291.298 64.386C291.102 64.5073 291.004 64.6893 291.004 64.932ZM308.307 69.51L307.005 70.266L306.067 69.258C305.292 69.874 304.382 70.182 303.337 70.182C302.338 70.182 301.526 69.9253 300.901 69.412C300.285 68.8987 299.977 68.1987 299.977 67.312C299.977 66.724 300.122 66.1827 300.411 65.688C300.71 65.1933 301.139 64.7967 301.699 64.498C301.326 63.9847 301.139 63.4153 301.139 62.79C301.139 61.9687 301.424 61.3013 301.993 60.788C302.572 60.2747 303.281 60.018 304.121 60.018C304.793 60.018 305.4 60.1953 305.941 60.55C306.482 60.9047 306.884 61.4087 307.145 62.062L305.773 62.846C305.642 62.454 305.432 62.146 305.143 61.922C304.854 61.698 304.518 61.586 304.135 61.586C303.743 61.586 303.412 61.7027 303.141 61.936C302.88 62.16 302.749 62.4587 302.749 62.832C302.749 63.028 302.791 63.224 302.875 63.42C302.959 63.616 303.048 63.7793 303.141 63.91C303.244 64.0313 303.393 64.1947 303.589 64.4L305.969 66.976C306.202 66.5 306.37 65.9307 306.473 65.268L307.845 66.052C307.677 66.836 307.406 67.5267 307.033 68.124L308.307 69.51ZM303.421 68.684C304.046 68.684 304.588 68.5113 305.045 68.166L302.637 65.576C301.946 65.9213 301.601 66.458 301.601 67.186C301.601 67.6433 301.76 68.0073 302.077 68.278C302.394 68.5487 302.842 68.684 303.421 68.684ZM320.053 70L319.367 68.026H315.195L314.509 70H312.759L316.315 60.2H318.247L321.789 70H320.053ZM315.727 66.514H318.835L317.281 62.09L315.727 66.514ZM323.122 60.2H324.732V70H323.122V60.2Z",
    fill: "#282D72"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_398_3098",
    x: 68,
    y: 81,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_398_3098"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_398_3098",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_398_3098",
    x: 142,
    y: 71,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_398_3098"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_398_3098",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_398_3098",
    x: 221,
    y: 37,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_398_3098"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_398_3098",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_398_3098",
    x: 317,
    y: 27,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_398_3098"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_398_3098",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_398_3098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 177,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.f2cfc570d93ba913aa163a5baf2af121.svg";
export { ForwardRef as ReactComponent };